import { useEffect } from "react";
import { useLocation, useNavigationType } from "@/lib/router-compat";

const RouteScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType !== "POP") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, navType]);

  return null;
};

export default RouteScrollToTop;
